import React from 'react';

function DiseaseIdentify(props) {
    return (
        <div>
            <p>
                With the background research completed, it is apparent that the current
                agriculture industry needs an intelligent system that can predict the probability
                of a plant becoming infected with a disease and then predict the next crop that
                the disease could be dispersed to. Identify the next crop to which the illness might
                spread. In order to address this problem, the system presented in this project
                brings the farmers together as well as the Industrial users such as Agrarians and
                Researchers.
                This enables the users to capture or select an existing photograph of a crop leaf to be diagnosed using
                the disease identification feature and receive feedback on the name of the identified disease (if a
                presence of a disease is detected by the system), the probability of the identified disease spreading on
                the crop, disease information, and recommended treatment options, including biocidal product
                recommendations based on the type and severity of the identified disease. </p>
            <br/>
            <br/>
        </div>
    );
}

export default DiseaseIdentify;
